module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "operation_box"
  }, [_c('img', {
    staticClass: "bd",
    attrs: {
      "src": "/static/img/operationsuccess.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "main",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.result))]), _vm._v(" "), _c('span', {
    staticClass: "submain",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "return-button",
    on: {
      "click": _vm.goHome
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("返回主页")])]), _vm._v(" "), (_vm.ifShowLottery && _vm.lotteryUrl) ? _c('a', {
    attrs: {
      "href": _vm.lotteryUrl
    }
  }, [_c('img', {
    staticClass: "lottery-image",
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/首单抽奖.png"
    }
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("领取优惠券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb80526","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Activities/GetCoupon/OperationResult.vue
// module id = 1583
// module chunks = 8